import axios from '@/libs/api.request'
const dataBrain = {
    getTYLine: () => {
        return axios.get({//实时营业额
            url: '/DataBrain/TYLine'
        })
    },
    getSalesDept: () => {//门店营业额排行 单品店营业状况
        return axios.get({
            url: '/DataBrain/SalesDept'
        })
    },
    getSalesInfo: () => {//流水
        return axios.get({
            url: '/DataBrain/SalesInfo'
        })
    },
    getMainSalesSum: () => {//获取营业额信息
        return axios.get({
            url: '/DataBrain/MainSalesSum'
        })
    },
    getTopMember: () => {//会员数据 （泛会员）
        return axios.get({
            url: '/DataBrain/TopMember'
        })
    },
    getProductSalesOrder: () => {//产品销售额排名
        return axios.get({
            url: '/DataBrain/ProductSalesOrder'
        })
    },
}
export default dataBrain


// WEBPACK FOOTER //
// ./src/api/api-dataBrain.js